export default __webpack_public_path__ + "static/media/android-chrome-512x512.6ceb81d9.png";